import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Create wish", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_5 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitClicked())),
              type: "submit",
              value: "Create",
              class: "btn btn-primary"
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_RouterLink, { to: { name: 'wishes' } }, {
        default: _withCtx(() => [
          _createTextVNode("Back to Metrices")
        ]),
        _: 1
      })
    ])
  ], 64))
}